import { novaClient } from "@/lib/trpc";

// The user sheet's single profile fetch. Every consumer (header, comms rail,
// tabs) calls this with the same input, so react-query serves them all from one
// cache entry instead of each threading the data down through props.
export const useGetCandidacySheetData = ({
  includeCandidacyHydration,
  jobId,
  userId,
}: {
  // Adds the search-style candidacy payload (score, pipelines, comms) to the
  // response — only review surfaces without a search result need it.
  includeCandidacyHydration?: boolean;
  jobId?: string;
  userId: number;
}) => {
  return novaClient.internal.user.active.getCandidacySheetData.useQuery(
    {
      includeCandidacyHydration,
      jobId,
      userId,
    },
    {
      // Hosts that derive the worker id from another query pass 0 while it
      // loads — don't fire a request for a user that can't exist.
      enabled: userId > 0,
      // Stepping to the next candidate holds the previous profile until the
      // new one lands, so the sheet never blanks out mid-queue.
      placeholderData: (previousData) => previousData,
      // This query is observed throughout the sheet. Do not refetch a failed
      // request each time another tab/header child mounts.
      retry: false,
      retryOnMount: false,
    },
  );
};
